/**
 * Удерживает Tab внутри модалки. Используется BaseModal для обычного и
 * динамического содержимого; не управляет открытием, Escape или стеком окон.
 */
export function createModalTabHandler(modal) {
  return (event) => {
    if (event.key !== "Tab") return;
    // Вкладки и async-загрузка меняют кнопки после открытия окна.
    const focusable = [...modal.querySelectorAll("button, [href], input, select, textarea, [tabindex]")]
      .filter((element) => !element.disabled && element.tabIndex >= 0 &&
        !element.closest("[hidden], [inert]") &&
        getComputedStyle(element).display !== "none" && getComputedStyle(element).visibility !== "hidden");
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (!first) {
      event.preventDefault();
      modal.focus({ preventScroll: true });
    } else if (document.activeElement === modal || !modal.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first)?.focus({ preventScroll: true });
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus({ preventScroll: true });
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus({ preventScroll: true });
    }
  };
}

/**
 * Возвращает фокус на элемент, открывший верхнюю модалку, если пользователь
 * не успел самостоятельно перевести фокус за пределы закрываемого окна.
 */
export function restoreModalFocus(target, modal, wasTopModal) {
  if (!wasTopModal || !target?.isConnected || target === document.body ||
      !modal?.contains(document.activeElement)) return;

  target.focus({ preventScroll: true });
}
